import { is } from '@common/is/is'

import globals from '../../globals'

import styles from './Title.css'

class Title extends HTMLElement {
  public connectedCallback (): void {
    this.appendChild(
      <Fragment>
        <div className={ styles.top } />

        <h1 className={ styles.bottom }>
          { is.undefined(globals.title) ? '?' : globals.title }
        </h1>
      </Fragment>
    )
  }
}

customElements.define('a-title', Title)
